"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UndermoonDrugLordsNetwork = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const CardRenderer_1 = require("../render/CardRenderer");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const Resources_1 = require("../../Resources");
const Card_1 = require("../Card");
const Size_1 = require("../render/Size");
class UndermoonDrugLordsNetwork extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.UNDERMOON_DRUG_LORDS_NETWORK,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.MOON],
            cost: 2,
            metadata: {
                description: 'Increase your M€ production 1 step per 2 steps of Colony Rate.',
                cardNumber: 'M81',
                victoryPoints: -1,
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => {
                        pb.megacredits(1);
                    }).nbsp(Size_1.Size.SMALL).slash().moonColonyRate({ amount: 2 });
                }),
            },
        });
    }
    ;
    play(player) {
        const gain = Math.floor(MoonExpansion_1.MoonExpansion.moonData(player.game).colonyRate / 2);
        player.addProduction(Resources_1.Resources.MEGACREDITS, gain, { log: true });
        return undefined;
    }
    getVictoryPoints() {
        return -1;
    }
}
exports.UndermoonDrugLordsNetwork = UndermoonDrugLordsNetwork;
//# sourceMappingURL=UndermoonDrugLordsNetwork.js.map